/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Header metadata in canonical camelCase format
 * @export
 * @interface ExtractedDataResponseMetadata
 */
export interface ExtractedDataResponseMetadata {
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    insuredName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    insuredAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    insuredPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    insuredEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    estimatorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    estimatorCompany?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    estimatorAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    estimatorPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    estimatorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    claimNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    typeOfLoss?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    dateContacted?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    dateOfLoss?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    dateReceived?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    dateInspected?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    dateEntered?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    dateEstimateCompleted?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDataResponseMetadata
     */
    priceList?: string | null;
}

/**
 * Check if a given object implements the ExtractedDataResponseMetadata interface.
 */
export function instanceOfExtractedDataResponseMetadata(value: object): value is ExtractedDataResponseMetadata {
    return true;
}

export function ExtractedDataResponseMetadataFromJSON(json: any): ExtractedDataResponseMetadata {
    return ExtractedDataResponseMetadataFromJSONTyped(json, false);
}

export function ExtractedDataResponseMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractedDataResponseMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'insuredAddress': json['insuredAddress'] == null ? undefined : json['insuredAddress'],
        'insuredPhone': json['insuredPhone'] == null ? undefined : json['insuredPhone'],
        'insuredEmail': json['insuredEmail'] == null ? undefined : json['insuredEmail'],
        'estimatorName': json['estimatorName'] == null ? undefined : json['estimatorName'],
        'estimatorCompany': json['estimatorCompany'] == null ? undefined : json['estimatorCompany'],
        'estimatorAddress': json['estimatorAddress'] == null ? undefined : json['estimatorAddress'],
        'estimatorPhone': json['estimatorPhone'] == null ? undefined : json['estimatorPhone'],
        'estimatorEmail': json['estimatorEmail'] == null ? undefined : json['estimatorEmail'],
        'claimNumber': json['claimNumber'] == null ? undefined : json['claimNumber'],
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'typeOfLoss': json['typeOfLoss'] == null ? undefined : json['typeOfLoss'],
        'dateContacted': json['dateContacted'] == null ? undefined : json['dateContacted'],
        'dateOfLoss': json['dateOfLoss'] == null ? undefined : json['dateOfLoss'],
        'dateReceived': json['dateReceived'] == null ? undefined : json['dateReceived'],
        'dateInspected': json['dateInspected'] == null ? undefined : json['dateInspected'],
        'dateEntered': json['dateEntered'] == null ? undefined : json['dateEntered'],
        'dateEstimateCompleted': json['dateEstimateCompleted'] == null ? undefined : json['dateEstimateCompleted'],
        'priceList': json['priceList'] == null ? undefined : json['priceList'],
    };
}

export function ExtractedDataResponseMetadataToJSON(json: any): ExtractedDataResponseMetadata {
    return ExtractedDataResponseMetadataToJSONTyped(json, false);
}

export function ExtractedDataResponseMetadataToJSONTyped(value?: ExtractedDataResponseMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredName': value['insuredName'],
        'insuredAddress': value['insuredAddress'],
        'insuredPhone': value['insuredPhone'],
        'insuredEmail': value['insuredEmail'],
        'estimatorName': value['estimatorName'],
        'estimatorCompany': value['estimatorCompany'],
        'estimatorAddress': value['estimatorAddress'],
        'estimatorPhone': value['estimatorPhone'],
        'estimatorEmail': value['estimatorEmail'],
        'claimNumber': value['claimNumber'],
        'policyNumber': value['policyNumber'],
        'typeOfLoss': value['typeOfLoss'],
        'dateContacted': value['dateContacted'],
        'dateOfLoss': value['dateOfLoss'],
        'dateReceived': value['dateReceived'],
        'dateInspected': value['dateInspected'],
        'dateEntered': value['dateEntered'],
        'dateEstimateCompleted': value['dateEstimateCompleted'],
        'priceList': value['priceList'],
    };
}

